import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { handleData } from '../helper'
import {
  getBiggestCreditRisk,
  getBiggestPerformance,
  getHighestCreditRisk,
  getHighestPerformance,
  getLargestDeclineCreditRisk,
  getLargestDeclinePerformance,
} from './thunk'

export const BOX_KEY = {
  HIGHEST: 'HIGHEST',
  BIGGEST: 'BIGGEST',
  LARGEST: 'LARGEST',
}

const initialState = {
  loading: {
    [BOX_KEY.BIGGEST]: true,
    [BOX_KEY.HIGHEST]: true,
    [BOX_KEY.LARGEST]: true,
  },
  data: {
    [BOX_KEY.BIGGEST]: {},
    [BOX_KEY.HIGHEST]: {},
    [BOX_KEY.LARGEST]: {},
  },
  ids: {
    [BOX_KEY.BIGGEST]: [],
    [BOX_KEY.HIGHEST]: [],
    [BOX_KEY.LARGEST]: [],
  },
  dataPer: {
    [BOX_KEY.BIGGEST]: {},
    [BOX_KEY.HIGHEST]: {},
    [BOX_KEY.LARGEST]: {},
  },
  idsPer: {
    [BOX_KEY.BIGGEST]: [],
    [BOX_KEY.HIGHEST]: [],
    [BOX_KEY.LARGEST]: [],
  },
}

const slice = createSlice({
  name: 'portfolio/score/topCompanies/scoreTrend',
  initialState,
  reducers: {
    resetSore: () => initialState,
  },
  extraReducers: (builder) => {
    //getHighestCreditRisk
    builder.addCase(getHighestCreditRisk.pending, (state) => {
      state.ids[BOX_KEY.HIGHEST] = []
      state.loading[BOX_KEY.HIGHEST] = true
    })
    builder.addCase(
      getHighestCreditRisk.fulfilled,
      (state, { payload = [] }) => {
        state.data[BOX_KEY.HIGHEST] = handleData(payload)
        state.ids[BOX_KEY.HIGHEST] = payload.map((item) => item.rank)
        state.loading[BOX_KEY.HIGHEST] = false
      },
    )
    builder.addCase(
      getHighestCreditRisk.rejected,
      (state, { payload = [] }) => {
        state.loading[BOX_KEY.HIGHEST] = payload.loading
      },
    )
    //getHighestPerformance
    builder.addCase(getHighestPerformance.pending, (state) => {
      state.idsPer[BOX_KEY.HIGHEST] = []
      state.loading[BOX_KEY.HIGHEST] = true
    })
    builder.addCase(
      getHighestPerformance.fulfilled,
      (state, { payload = [] }) => {
        state.dataPer[BOX_KEY.HIGHEST] = handleData(payload)
        state.idsPer[BOX_KEY.HIGHEST] = payload.map((item) => item.rank)
        state.loading[BOX_KEY.HIGHEST] = false
      },
    )
    builder.addCase(
      getHighestPerformance.rejected,
      (state, { payload = [] }) => {
        state.loading[BOX_KEY.HIGHEST] = payload.loading
      },
    )
    //getBiggestCreditRisk
    builder.addCase(getBiggestCreditRisk.pending, (state) => {
      state.ids[BOX_KEY.BIGGEST] = []
      state.loading[BOX_KEY.BIGGEST] = true
    })
    builder.addCase(
      getBiggestCreditRisk.fulfilled,
      (state, { payload = [] }) => {
        state.data[BOX_KEY.BIGGEST] = handleData(payload)
        state.ids[BOX_KEY.BIGGEST] = payload.map((item) => item.rank)
        state.loading[BOX_KEY.BIGGEST] = false
      },
    )
    builder.addCase(
      getBiggestCreditRisk.rejected,
      (state, { payload = [] }) => {
        state.loading[BOX_KEY.BIGGEST] = payload.loading
      },
    )
    //getBiggestPerformance
    builder.addCase(getBiggestPerformance.pending, (state) => {
      state.idsPer[BOX_KEY.BIGGEST] = []
      state.loading[BOX_KEY.BIGGEST] = true
    })
    builder.addCase(
      getBiggestPerformance.fulfilled,
      (state, { payload = [] }) => {
        state.dataPer[BOX_KEY.BIGGEST] = handleData(payload)
        state.idsPer[BOX_KEY.BIGGEST] = payload.map((item) => item.rank)
        state.loading[BOX_KEY.BIGGEST] = false
      },
    )
    builder.addCase(
      getBiggestPerformance.rejected,
      (state, { payload = [] }) => {
        state.loading[BOX_KEY.BIGGEST] = payload.loading
      },
    )
    //getLargestDeclineCreditRisk
    builder.addCase(getLargestDeclineCreditRisk.pending, (state) => {
      state.ids[BOX_KEY.LARGEST] = []
      state.loading[BOX_KEY.LARGEST] = true
    })
    builder.addCase(
      getLargestDeclineCreditRisk.fulfilled,
      (state, { payload = [] }) => {
        state.data[BOX_KEY.LARGEST] = handleData(payload)
        state.ids[BOX_KEY.LARGEST] = payload.map((item) => item.rank)
        state.loading[BOX_KEY.LARGEST] = false
      },
    )
    builder.addCase(
      getLargestDeclineCreditRisk.rejected,
      (state, { payload = [] }) => {
        state.loading[BOX_KEY.LARGEST] = payload.loading
      },
    )
    //getLargestDeclinePerformance
    builder.addCase(getLargestDeclinePerformance.pending, (state) => {
      state.idsPer[BOX_KEY.LARGEST] = []
      state.loading[BOX_KEY.LARGEST] = true
    })
    builder.addCase(
      getLargestDeclinePerformance.fulfilled,
      (state, { payload = [] }) => {
        state.dataPer[BOX_KEY.LARGEST] = handleData(payload)
        state.idsPer[BOX_KEY.LARGEST] = payload.map((item) => item.rank)
        state.loading[BOX_KEY.LARGEST] = false
      },
    )
    builder.addCase(
      getLargestDeclinePerformance.rejected,
      (state, { payload = [] }) => {
        state.loading[BOX_KEY.LARGEST] = payload.loading
      },
    )
  },
})

export const getLoading = (state) =>
  Object.values(state[slice.name].loading).some(Boolean)

export const getDataTableHighest = (rowId, colId) => (state) =>
  state[slice.name].data[BOX_KEY.HIGHEST][rowId][colId]
export const getDataTableBiggest = (rowId, colId) => (state) =>
  state[slice.name].data[BOX_KEY.BIGGEST][rowId][colId]
export const getDataTableLargest = (rowId, colId) => (state) =>
  state[slice.name].data[BOX_KEY.LARGEST][rowId][colId]

export const getDataTablePerHighest = (rowId, colId) => (state) =>
  state[slice.name].dataPer[BOX_KEY.HIGHEST][rowId][colId]
export const getDataTablePerBiggest = (rowId, colId) => (state) =>
  state[slice.name].dataPer[BOX_KEY.BIGGEST][rowId][colId]
export const getDataTablePerLargest = (rowId, colId) => (state) =>
  state[slice.name].dataPer[BOX_KEY.LARGEST][rowId][colId]

export const getIdsTable = (key) => (state) => state[slice.name].ids[key]
export const getIdsTablePer = (key) => (state) => state[slice.name].idsPer[key]

export const { resetSore } = slice.actions

register(slice.name, slice.reducer)
